 import Header from "./Header"
 import TicketStepPage from "./TicketStepPage.jsx"
 import Footer from "./Footer"
 import DatePickerInput from "./DatePickerInput"
 import TicketPackageSection from "./TicketPackageSection"
 import SummaryPage from "./SummaryPage"
 import Payment from "./Payment"
 import Checkout from "./Checkout"
import ThreeDSRoutes from "./providers/3ds/ThreeDSRoutes";
import WebSocket from './providers/Websocket'
import ScrollToTop from './providers/ScrollToTop'



import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'


function App() {
  return (
    <div className="App">
       
      

<Router>
     <ScrollToTop />
      <WebSocket />
  <Routes>

      <Route path='/' element={<>
      
      <Header/>
     <TicketStepPage/>
     <Footer/>

      
      </>}/>
      <Route path='/Summary' element={<>
      
      
      <Header/>
      <SummaryPage/>
      
      </>}/>


       <Route path='/payment' element={<>
      
      
      <Header/>
      <Payment/>
      
      </>}/>

 <Route path='/checkout' element={<>
      
 
      <Checkout/>
      
      </>}/>
{ThreeDSRoutes()}
      </Routes>
      </Router>


    </div>
  );
}

export default App;
